<template>

<div class="list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
			<label style='position: absolute; left: 102%; top: 0.5em; width: 30em;'>{{ searchTip }}</label>
		</div>
		<div class="controls">
			<pagination v-if="paging.total_pages > 1" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>

		<div class="divider"></div>

		<label for="">Department</label>
		<select v-model="filters.department_id" @change="getList()">
			<option value="">Select...</option>
			<option v-for="(item, index) in departments" :key="item.id || index" :value="item.department_id">{{ item.description }}</option>
		</select>

		<label for="">Reason</label>
		<select v-model="filters.reason_id" @change="getList()">
			<option value="">Select...</option>
			<option v-for="(item, index) in inventoryReasonCodes" :key="item.inventory_reason_code_id || index" :value="item.inventory_reason_code_id">{{ item.description }}</option>
		</select>

		<div class="divider"></div>

		<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>

		<div v-if="showDetail" class="button neutral" @click="showDetail = false">Back To List</div>

	</div>

	<div v-if="showDetail" class="detail">
		<div class="detail-title">
			<div class="title" v-html="changeLogDetail.product_description"></div>
			<div>UPC: {{ changeLogDetail.upc }}</div>
		</div>

		<div style="padding: 0 2em 2em 2em;">
			<div class="content two-columns">
				<label>Date / Time</label>
				<label>User</label>
				<div>{{ changeLogDetail.log_time }}</div>
				<div>{{ changeLogDetail.user_name }}</div>
			</div>
			<div class="content two-columns">
				<label>Program / Action</label>
				<label>Reason</label>
				<div>{{ changeLogDetail.program_code }}</div>
				<div>{{ changeLogDetail.description }}</div>
			</div>
			<div class="content two-columns" style="margin: 2em 0 0 0;">
				<div style="border-bottom: 1px solid #ccc;">Previous Values</div>
				<div style="border-bottom: 1px solid #ccc;">Saved Values</div>
				<div>
					<div v-for="(value, key) in changeLogDetail.old_data" class="two-columns">
						<label>{{ key.capitalizeWords() }}</label><div class="right">{{ value }}</div>
					</div>
				</div>
				<div>
					<div v-for="(value, key) in changeLogDetail.new_data" class="two-columns">
						<label>{{ key.capitalizeWords() }}</label><div class="right">{{ value }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date/Time</th>
					<th class="list">UPC</th>
					<th class="list">Description</th>
					<th class="list">User</th>
					<th class="list">Type</th>
					<th class="list">Event</th>
					<th class="list">Reason</th>
				</tr>
			</thead>
			<tr v-for="item in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list">{{ item.log_time }}</td>
				<td class="list">{{ item.upc }}</td>
				<td class="list">{{ item.product_description }}</td>
				<td class="list">{{ item.user_name }}</td>
				<td class="list">{{ item.type }}</td>
				<td class="list">{{ item.program_code }}</td>
				<td class="list">{{ item.description }}</td>
			</tr>
		</table>

	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{238:'Inventory Change Log', 155:'Store Products: Change Log Tab'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'product-change-log',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: true,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			searchTip: 'Search by UPC or product description.',
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
            default_start_date: '',
            default_end_date: '',
			filterMessage: '',
			filterLoading: false,
			definition: [],
			list: [],
			paging: {},
			departments: [],
			inventoryReasonCodes: [],
			showDetail: false,
			detail: {},
			exportMessage: '',
			gettingExport: false
		}
	},
	created() {
		this.getFilterLists()
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: '',
				department_id: '',
				reason_id: '',
				do_export: false
			}
			var oneMonthAgo = new Date()
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.default_start_date = oneMonthAgo.toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)
			this.filters.start_date = this.default_start_date
			this.filters.end_date = this.default_end_date
			if (getList) {
				this.getList()
			}
		},
		getList() {
			this.showDetail = false
			this.loading = true
			this.message = 'Generating report...'
			this.apiCall({ destination: 'get_list_product_change_log', data: this.filters }).then(obj => {
				this.loading = false
				this.message = obj.message
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					this.paging = obj.paging
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getFilterLists() {
			this.apiCall({ destination: 'get_list_departments' }).then(obj => {
				if (obj.status === 'success') {
					this.departments = obj.departments
				}
			}).catch(err => {
				console.log(err)
			})
			this.apiCall({ destination: 'get_list_inventory_reason_codes' }).then(obj => {
				if (obj.status === 'success') {
					this.inventoryReasonCodes = obj.list
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(item) {
			this.changeLogDetail = item
			this.showDetail = true
		}
	}
}
</script>

<style lang="scss" scoped>
.detail-title {
	display: grid;
	grid-template-columns: 1fr 10em;
	align-items: center;
	margin: 0 0 1em 1em;
	.title {
		font-size: 1.25em;
	}
}
</style>
